export type Reviewer = {
  id: string
  salutation: string
  first_name: string
  surname: string
  email: string
  phone_number: string | null
  position_id: string | null
  can_review_profiles: boolean
  is_active: boolean
  created_by: string | null
  created_at: string | null
  deleted_at: string | null
}

export type ReviewerListParams = {
  with_trashed?: boolean
  /** When true, list only soft-deleted reviewers (Show Deleted filter). */
  only_trashed?: boolean
  page?: number
  per_page?: number
  search?: string
  name?: string
  email?: string
  is_active?: boolean
  can_review_profiles?: boolean
}

export type ReviewerFormPayload = {
  salutation: string
  first_name: string
  surname: string
  email: string
  phone_number?: string
  position_id?: string
  can_review_profiles: boolean
  is_active?: boolean
}

export const REVIEWER_SALUTATION_OPTIONS = [
  { value: 'miss', label: 'Miss' },
  { value: 'mr', label: 'Mr' },
  { value: 'mrs', label: 'Mrs' },
  { value: 'ms', label: 'Ms' },
  { value: 'dr', label: 'Dr' },
  { value: 'prof', label: 'Prof' },
] as const
